import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
export default {
  data: () => ({
    name: "Country",
    mainPage: "",
    subPage: "",
    pageUrl: "",
    backSlash: true,
    userId: EncryptUtility.localStorageDecrypt("userID"),
    refresh: true,
    totalRecords: 0,
    searchCarrierList: "",
    isActive: 1,
    carrierListData: [],
    carrierLevelAddDialog: false,
    carrierLvlName: "",
    carrierLevelUpdateDialog: false,
    updateIsActive: 1,
    updateCarrierLvlName: "",
    updateCarrierDet: [],
    headerCarrierList: [
      {
        text: "Name",
        value: "Name",
        align: "start",
        class: "primary customwhite--text",
      },
      {
        text: "Created Date",
        value: "CreatedDate",
        class: "primary customwhite--text",
      },
      {
        text: "Created By",
        value: "CreatedBy",
        class: "primary customwhite--text",
      },
      {
        text: "Modified Date",
        value: "ModifiedDate",
        class: "primary customwhite--text",
      },
      {
        text: "Modified By",
        value: "ModifiedBy",
        class: "primary customwhite--text",
      },
      {
        text: "Active",
        value: "active",
        class: "primary customwhite--text",
      },
      {
        text: "Actions",
        value: "actions",
        class: "primary customwhite--text",
      },
    ],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.getCarrierList();
  },
  mounted() {},
  methods: {
    //Reset Function
    resetFunction() {
      this.totalRecords = 0;
      this.searchCarrierList = "";
      this.isActive = 1;
      this.carrierListData = [];
      this.carrierLvlName = "";
      this.carrierLevelAddDialog = false;
      this.carrierLevelUpdateDialog = false;
      this.updateIsActive = 1;
      this.updateCarrierLvlName = "";
      this.updateCarrierDet = [];
      this.getCarrierList();
    },
    //On close of popup
    onCancel() {
      if (this.carrierLevelAddDialog) {
        this.carrierLvlName = "";
        this.$refs.carrierAddForm.resetValidation();
        this.carrierLevelAddDialog = false;
      }
      if (this.carrierLevelUpdateDialog) {
        this.updateCarrierLvlName = "";
        this.updateIsActive = 1;
        this.$refs.carrierUpdateForm.resetValidation();
        this.carrierLevelUpdateDialog = false;
      }
    },
    //Add a new carrier button
    addCarrier() {
      if (this.$refs.carrierAddForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        let obj = {
          Name: this.carrierLvlName,
          IsActive: 1,
          CreatedBy: parseInt(this.userId),
        };
        this.axios
          .post("cr/cr_carrier_insert", obj)
          .then((response) => {
            if (response.status == 200) {
              this.onCancel();
              this.getCarrierList();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Update carrier button
    updateCarrier() {
      if (this.$refs.carrierUpdateForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        let obj = {
          CarrierId: parseInt(this.updateCarrierDet[0]?.CarrierId),
          Name: this.updateCarrierLvlName,
          IsActive: parseInt(this.updateIsActive),
          ModifiedBy: parseInt(this.userId),
        };
        this.axios
          .post("cr/cr_carrier_update", obj)
          .then((response) => {
            if (response.status == 200) {
              this.onCancel();
              this.getCarrierList();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Carrier Details
    carrierDetails(item) {
      this.updateCarrierDet = [];
      this.updateCarrierDet.push(item);
      this.updateCarrierLvlName = this.updateCarrierDet[0]?.Name;
      this.updateIsActive = this.updateCarrierDet[0]?.IsActive == true ? 1 : 0;
      this.carrierLevelUpdateDialog = true;
    },
    //Get Carrier List
    getCarrierList() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("cr/cr_carrier_list?IsActive=" + this.isActive)
        .then((response) => {
          if (response.status == 200) {
            let responseData = JSON.parse(response.data.body.message);
            if (responseData !== null) {
              const newArr = responseData.map((obj) => {
                return {
                  ...obj,
                  CreatedDate: Utility.displayDateFormat(obj.CreatedDate),
                  ModifiedDate: obj.ModifiedDate !== null ? Utility.displayDateFormat(obj.CreatedDate) : "",
                };
              });
              this.carrierListData = newArr;
              this.totalRecords = newArr.length;
            } else {
              this.carrierListData = [];
              this.totalRecords = 0;
              let Alert = {
                type: "error",
                isShow: true,
                message: "No data based on the selected criteria",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //On Click of Favorite icon
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
